var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9688,
    cy: 13.6094,
    r: 13,
    fill: "#4D4D4D",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.01041,
    y: 8.19141,
    width: 0.766019,
    height: 16.0864,
    rx: 0.38301,
    transform: "rotate(-45 8.01041 8.19141)",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.766019
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3848,
    y: 7.65103,
    width: 0.766019,
    height: 16.0864,
    rx: 0.38301,
    transform: "rotate(45 19.3848 7.65103)",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.766019
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.2df4f75f63b5cccba6727632763979b0.svg";
export { ForwardRef as ReactComponent };